import { createStore } from 'vuex';

const store = createStore({
  state() {
    return {
      // 你的状态
    };
  },
  mutations: {
    // 你的 mutations
  },
  actions: {
    // 你的 actions
  },
  modules: {
    // 你的模块
  }
});

export default store;
